import { render, staticRenderFns } from "./select-field.vue?vue&type=template&id=781fc5ce"
import script from "./select-field.ts?vue&type=script&lang=js&external"
export * from "./select-field.ts?vue&type=script&lang=js&external"
import style0 from "./select-field.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
